import { useQuery } from '@tanstack/react-query';

import { OilStoreTypeService } from 'services/openapi';

import { OilStoreTypeQueryKeys } from './constants';

export const useGetOilStoreTypeDetailQuery = (id: string, enabled = true) => {
  return useQuery({
    queryKey: [OilStoreTypeQueryKeys.GET_OIL_STORE_TYPE_DETAIL, id],
    queryFn: () => OilStoreTypeService.oilStoreTypeControllerGetDetail(id),
    enabled: enabled && !!id,
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
};
